import AdditionalRequestsTypes from "@upclaim/prisma/seeds/claims_additional_requests_types.json";
import { AdditionalRequestType } from "@/interfaces/data-contracts";

import { ScaleIcon, BanIcon, MailMinusIcon, ReceiptEuroIcon } from "lucide-vue-next";

export type RequestTypes = AdditionalRequestType;

const AdditionalRequestsTypesMap: { [key in RequestTypes]: { icon: any, value: key; label: string; } } = {
  "ARTICLE_700": { icon: ScaleIcon, value: "ARTICLE_700", label: "Article 700 du CPC" },
  "PROCEDURE_COSTS": { icon: ReceiptEuroIcon, value: "PROCEDURE_COSTS", label: "Dépens" },
  "ABUSIVE_RESISTANCE": { icon: BanIcon, value: "ABUSIVE_RESISTANCE", label: "Résistance Abusive" },
  "LACK_OF_INFORMATION_NOTICE": { icon: MailMinusIcon, value: "LACK_OF_INFORMATION_NOTICE", label: "Défaut de notice d'information" },
};

export {
  AdditionalRequestsTypesMap,
}